import { TestIds } from '@/shared/test-ids';

export type AssetTypeFilterProp = {
  title: string;
  onClick: () => void;
  isClicked: boolean;
};
export const AssetTypeFilter = ({ title, onClick, isClicked }: AssetTypeFilterProp) => {
  return (
    <div
      className={`flex h-9 cursor-pointer items-center rounded-lg border bg-primary-white px-5 text-base ${
        isClicked ? 'bg-secondary-pale-blue-gray font-bold' : ''
      }`}
      data-testid={TestIds.eventCeremony.assetFilterButton}
      onClick={onClick}>
      {title}
    </div>
  );
};
